/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScreeningClearanceRulesAnalysisWithRunInfo } from './InternalApiScreeningClearanceRulesAnalysisWithRunInfo';
import {
    InternalApiScreeningClearanceRulesAnalysisWithRunInfoFromJSON,
    InternalApiScreeningClearanceRulesAnalysisWithRunInfoFromJSONTyped,
    InternalApiScreeningClearanceRulesAnalysisWithRunInfoToJSON,
    InternalApiScreeningClearanceRulesAnalysisWithRunInfoToJSONTyped,
} from './InternalApiScreeningClearanceRulesAnalysisWithRunInfo';

/**
 * 
 * @export
 * @interface InternalApiScreeningClearanceRulesAnalysesPage
 */
export interface InternalApiScreeningClearanceRulesAnalysesPage {
    /**
     * 
     * @type {number}
     * @memberof InternalApiScreeningClearanceRulesAnalysesPage
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScreeningClearanceRulesAnalysesPage
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScreeningClearanceRulesAnalysesPage
     */
    total: number;
    /**
     * 
     * @type {Array<InternalApiScreeningClearanceRulesAnalysisWithRunInfo>}
     * @memberof InternalApiScreeningClearanceRulesAnalysesPage
     */
    content: Array<InternalApiScreeningClearanceRulesAnalysisWithRunInfo>;
}

/**
 * Check if a given object implements the InternalApiScreeningClearanceRulesAnalysesPage interface.
 */
export function instanceOfInternalApiScreeningClearanceRulesAnalysesPage(value: object): value is InternalApiScreeningClearanceRulesAnalysesPage {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function InternalApiScreeningClearanceRulesAnalysesPageFromJSON(json: any): InternalApiScreeningClearanceRulesAnalysesPage {
    return InternalApiScreeningClearanceRulesAnalysesPageFromJSONTyped(json, false);
}

export function InternalApiScreeningClearanceRulesAnalysesPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScreeningClearanceRulesAnalysesPage {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'size': json['size'],
        'total': json['total'],
        'content': ((json['content'] as Array<any>).map(InternalApiScreeningClearanceRulesAnalysisWithRunInfoFromJSON)),
    };
}

export function InternalApiScreeningClearanceRulesAnalysesPageToJSON(json: any): InternalApiScreeningClearanceRulesAnalysesPage {
    return InternalApiScreeningClearanceRulesAnalysesPageToJSONTyped(json, false);
}

export function InternalApiScreeningClearanceRulesAnalysesPageToJSONTyped(value?: InternalApiScreeningClearanceRulesAnalysesPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'total': value['total'],
        'content': ((value['content'] as Array<any>).map(InternalApiScreeningClearanceRulesAnalysisWithRunInfoToJSON)),
    };
}

